import { useEffect, useState } from "react";
import Apiservice from "../Apiservice";

const FloaterStaffDetails = () => {
    const [loading, setLoading] = useState(true);
    const [floaterCredit, setFloaterCredit] = useState([]);
    const [editId, setEditId] = useState(null);
    const [editData, setEditData] = useState({ username: "", password: "" });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        const result = await Apiservice.FloaterCreditGet({ status: 0 });
        if (result?.success) {
            setFloaterCredit(result.data);
        }
        setLoading(false);
    };

    const handleEdit = (floater) => {
        setEditId(floater.id);
        setEditData({
            username: floater.username,
            password: floater.password
        });
    };

    const handleCancel = () => {
        setEditId(null);
        setEditData({ username: "", password: "" });
    };

    const handleSave = async (id) => {
        await Apiservice.FloaterCreditUpdate({
            id,
            username: editData.username,
            password: editData.password
        });
        handleCancel();
        fetchData();
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this floater?")) {
            await Apiservice.FloaterCreditDelete({ id });
            fetchData();
        }
    };

    return (
        <div className="container mt-4">
            <h5 className="mb-3 fw-semibold text-primary">
                Floater Staff Details
            </h5>

            {loading ? (
                <div className="d-flex justify-content-center align-items-center vh-50">
                    <div className="text-center">
                        <div className="spinner-border text-primary" />
                        <p className="mt-2 small text-muted">Loading...</p>
                    </div>
                </div>
            ) : floaterCredit.length > 0 ? (
                <div className="row g-3">
                    {floaterCredit.map((floater) => (
                        <div className="col-md-6" key={floater.id}>
                            <div className="card shadow-sm border-0 rounded-3">
                                <div className="card-body">
                                    {/* Username */}
                                    <div className="mb-2">
                                        <label className="small text-muted">Username</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={
                                                editId === floater.id
                                                    ? editData.username
                                                    : floater.username
                                            }
                                            disabled={editId !== floater.id}
                                            onChange={(e) =>
                                                setEditData({
                                                    ...editData,
                                                    username: e.target.value
                                                })
                                            }
                                        />
                                    </div>

                                    {/* Password */}
                                    <div className="mb-3">
                                        <label className="small text-muted">Password</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={
                                                editId === floater.id
                                                    ? editData.password
                                                    : floater.password
                                            }
                                            disabled={editId !== floater.id}
                                            onChange={(e) =>
                                                setEditData({
                                                    ...editData,
                                                    password: e.target.value
                                                })
                                            }
                                        />
                                    </div>

                                    {/* Actions */}
                                    <div className="d-flex justify-content-end gap-2">
                                        {editId === floater.id ? (
                                            <>
                                                <button
                                                    className="btn btn-success btn-sm"
                                                    onClick={() => handleSave(floater.id)}
                                                >
                                                    Save
                                                </button>
                                                <button
                                                    className="btn btn-secondary btn-sm"
                                                    onClick={handleCancel}
                                                >
                                                    Cancel
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <button
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={() => handleEdit(floater)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => handleDelete(floater.id)}
                                                >
                                                    Delete
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="alert alert-light text-center border">
                    No floater staff found
                </div>
            )}
        </div>
    );
};

export default FloaterStaffDetails;
